import { Grid, Typography } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey, GlobalClassKeys } from "assets/jss/common-styles";
import MuiClickable from "components/MuiExtras/MuiClickable";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { Formaters } from "lib/Formarters";
import HtmlUtils from "lib/HtmlUtils";
import { PublicationAdminCourseDto } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { RoutePaths } from "routes/RouteConfig";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: PublicationAdminCourseDto;
}

type Props = IProps & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////

const CourseAdminPublisher: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { data: { recordInfo: { lastUpdateDate, creator, revisor } }, classes } = props;

    const publisherName = (creator.id != Session.user.id) ? creator.name : t("Glossary.You");
    const revisorName = (revisor.id != Session.user.id) ? revisor.name : t("Glossary.You");

    const hideName = creator.id == Session.user.id;

    const revision = creator.id != revisor.id
        ? `(${t("Common.Feed.Literals.EditedByText")} ${revisorName})`
        : null;

    const label = hideName ? t("Common.Feed.Literals.WasUpdatedText") : t("Common.Feed.Literals.UpdatedText");

    const relativeTime = Formaters.relativeTime(lastUpdateDate);

    return (
        <>
            {
                !hideName
                    ? (
                        <Grid container spacing={1}>
                            {
                                !hideName &&
                                <Grid item className={GlobalClassKeys.pushVCenter}>
                                    <MuiClickable
                                        onClick={
                                            () => {
                                                HtmlUtils.openUrlInNewWindow(RoutePaths.UserProfileViewer.replace(":id?", creator.id));
                                            }
                                        }
                                        title={t("Components.UserProfileAvatar.TitleText")}
                                    >
                                        <img src={creator.thumbnailUrl} alt={creator.name} className={classes.publisherPhoto} />
                                    </MuiClickable>
                                </Grid>
                            }
                            <Grid item className={GlobalClassKeys.grow}>
                                <Typography variant="subtitle2" component="div">
                                    <MuiColor variant="muted">
                                        <small>
                                            <div><b>{publisherName}</b></div>
                                            <div>{label} {relativeTime} {revision}</div>
                                        </small>
                                    </MuiColor>
                                </Typography>
                            </Grid>
                        </Grid>
                    )
                    : (
                        <Typography variant="subtitle2" component="div" >
                            <MuiColor variant="muted">
                                <small>{label} {relativeTime} {revision}</small>
                            </MuiColor>
                        </Typography>
                    )
            }
        </>
    );
};

export default CourseAdminPublisher;
